import axios from 'axios'

import * as types from '../types'
import router from '../../router'

const state = {
  orders: [],
  isSearchingOrders: false,
  loadingOrders: false,
  hasMoreOrders: true,
  quotations: [],
  isSearchingQuotations: false,
  loadingQuotations: false,
  hasMoreQuotations: true,
  isDownloadingOrder: false
}

const getters = {
  orders: (state) => {
    return state.orders
  },
  isSearchingOrders: (state) => {
    return state.isSearchingOrders
  },
  loadingOrders: (state) => {
    return state.loadingOrders
  },
  hasMoreOrders: (state) => {
    return state.hasMoreOrders
  },
  quotations: (state) => {
    return state.quotations
  },
  isSearchingQuotations: (state) => {
    return state.isSearchingQuotations
  },
  loadingQuotations: (state) => {
    return state.loadingQuotations
  },
  hasMoreQuotations: (state) => {
    return state.hasMoreQuotations
  },
  isDownloadingOrder: (state) => {
    return state.isDownloadingOrder
  }
}

const mutations = {
  [types.MUTATE_PUSH_ORDERS]: (state, orders) => {
    // Merge all the items to the array
    state.orders = state.orders.concat(orders)
  },
  [types.MUTATE_SET_ORDERS]: (state, orders) => {
    state.orders = orders
  },
  [types.MUTATE_LOADING_ORDERS]: (state, status) => {
    state.loadingOrders = status
  },
  [types.MUTATE_IS_SEARCHING_ORDERS]: (state, status) => {
    state.isSearchingOrders = status
  },
  [types.MUTATE_HAS_MORE_ORDERS]: (state, status) => {
    state.hasMoreOrders = status
  },
  [types.MUTATE_PUSH_QUOTATIONS]: (state, quotations) => {
    state.quotations = state.quotations.concat(quotations)
  },
  [types.MUTATE_SET_QUOTATIONS]: (state, quotations) => {
    state.quotations = quotations
  },
  [types.SEARCH_QUOTATIONS]: (state, isSearchingQuotations) => {
    state.isSearchingQuotations = isSearchingQuotations
  },
  [types.MUTATE_LOADING_QUOTATIONS]: (state, status) => {
    state.loadingQuotations = status
  },
  [types.MUTATE_HAS_MORE_QUOTATIONS]: (state, status) => {
    state.hasMoreQuotations = status
  },
  [types.MUTATE_REMOVE_QUOTATION]: (state, quotation) => {
    state.quotations = state.quotations.filter((i) => i.id !== quotation.id)
  },
  [types.MUTATE_DOWNLOADING_ORDER]: (state, isDownloadingOrder) => {
    state.isDownloadingOrder = isDownloadingOrder
  }
}

const actions = {
  [types.CLEAR_ORDERS]: ({ commit }) => {
    commit(types.MUTATE_SET_ORDERS, [])
  },
  [types.FETCH_ORDERS]: ({ commit, state, dispatch }, requestData) => {
    commit(types.MUTATE_LOADING_ORDERS, true)
    axios
      .post('/dashboard/orders', {
        search: requestData['search'],
        offset: requestData['offset']
      })
      .then(res => {
        commit(types.MUTATE_PUSH_ORDERS, res.data.orders)
        commit(types.MUTATE_HAS_MORE_ORDERS, res.data.more_results)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_ORDERS, false)
      })
  },
  [types.SEARCH_ORDERS]: ({ commit, state, dispatch }, requestData) => {
    commit(types.MUTATE_LOADING_ORDERS, true)
    commit(types.MUTATE_IS_SEARCHING_ORDERS, true)
    axios
      .post('/dashboard/orders', {
        search: requestData['search'],
        offset: requestData['offset']
      })
      .then(res => {
        commit(types.MUTATE_SET_ORDERS, res.data.orders)
        commit(types.MUTATE_HAS_MORE_ORDERS, res.data.more_results)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_ORDERS, false)
        commit(types.MUTATE_IS_SEARCHING_ORDERS, false)
      })
  },
  [types.COPY_ORDER]: ({ commit, state, dispatch }, order) => {
    commit(types.MUTATE_LOADING_ORDERS, true)
    commit(types.MUTATE_CALCULATING_STATUS, null)
    axios
      .get('/dashboard/copy/' + order.id)
      .then(res => {
        // Push to cart & redirect to tool page
        commit(types.MUTATE_CART, res.data.cart)
        localStorage.setItem('cart', JSON.stringify(res.data.cart))

        router.push({ name: 'tool' })
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_ORDERS, false)
      })
  },
  [types.DOWNLOAD_ORDER]: ({ commit, state, dispatch }, orderId) => {
    commit(types.MUTATE_DOWNLOADING_ORDER, true)
    axios
      .get('/dashboard/download/' + orderId)
      .then(res => {
        const link = document.createElement('a')
        link.href = res.data.excel
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_DOWNLOADING_ORDER, false)
      })
  },
  [types.CLEAR_QUOTATIONS]: ({ commit }) => {
    commit(types.MUTATE_SET_QUOTATIONS, [])
  },
  [types.FETCH_QUOTATIONS]: ({ commit, state, dispatch }, requestData) => {
    commit(types.MUTATE_LOADING_QUOTATIONS, true)
    axios
      .post('/dashboard/quotations', {
        search: requestData['search'],
        offset: requestData['offset']
      })
      .then(res => {
        commit(types.MUTATE_PUSH_QUOTATIONS, res.data.quotations)
        commit(types.MUTATE_HAS_MORE_QUOTATIONS, res.data.more_results)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_QUOTATIONS, false)
      })
  },
  [types.SEARCH_QUOTATIONS]: ({ commit, state, dispatch }, requestData) => {
    commit(types.MUTATE_LOADING_QUOTATIONS, true)
    commit(types.MUTATE_IS_SEARCHING_QUOTATIONS, true)
    axios
      .post('/dashboard/quotations', {
        search: requestData['search'],
        offset: requestData['offset']
      })
      .then(res => {
        commit(types.MUTATE_SET_QUOTATIONS, res.data.quotations)
        commit(types.MUTATE_HAS_MORE_QUOTATIONS, res.data.more_results)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_QUOTATIONS, false)
        commit(types.MUTATE_IS_SEARCHING_QUOTATIONS, false)
      })
  },
  [types.COPY_QUOTATION]: ({ commit, state, dispatch }, quotation) => {
    commit(types.MUTATE_IS_LOADING_QUOTATION_TO_TOOL, true)
    commit(types.MUTATE_CALCULATING_STATUS, null)
    axios
      .get('/dashboard/copy/' + quotation.id)
      .then(res => {
        // Push to cart & redirect to tool page
        commit(types.MUTATE_CART, res.data.cart)
        localStorage.setItem('cart', JSON.stringify(res.data.cart))

        router.push({ name: 'tool' })
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_IS_LOADING_QUOTATION_TO_TOOL, false)
      })
  },
  [types.DELETE_QUOTATION]: ({ commit, state, dispatch }, quotation) => {
    commit(types.MUTATE_LOADING_QUOTATIONS, true)
    axios
      .delete('/dashboard/destroy/' + quotation.id)
      .then(res => {
        // Remove the quotation from the quotations
        commit(types.MUTATE_REMOVE_QUOTATION, quotation)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_QUOTATIONS, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
